import { render, staticRenderFns } from "./CallOnShares.vue?vue&type=template&id=705b8f28&scoped=true&"
import script from "./CallOnShares.vue?vue&type=script&lang=js&"
export * from "./CallOnShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b8f28",
  null
  
)

export default component.exports